import BenefitElectionsModal from './BenefitElectionsModal';
import useModal from '../../../hooks/useModal';
import Button from '../../../components/Button';
import { Container } from 'react-bootstrap';
import { EnrollmentProvider } from '../../../providers/enrollment';

const BenefitElectionsModalDemoBody = () => {
  const [
    showBenefitElectionsModal,
    handleShowBenefitElectionsModal,
    handleCloseBenefitElectionsModal,
  ] = useModal();

  return (
    <Container>
      <h4>Benefit Elections Modal</h4>
      <Button onClick={handleShowBenefitElectionsModal}>
        Benefit Elections Modal
      </Button>

      <BenefitElectionsModal
        showBenefitElectionsModal={showBenefitElectionsModal}
        handleCloseBenefitElectionsModal={handleCloseBenefitElectionsModal}
      />
    </Container>
  );
};

const BenefitElectionsModalDemo = () => {
  return (
    <EnrollmentProvider>
      <BenefitElectionsModalDemoBody />
    </EnrollmentProvider>
  );
};

export default BenefitElectionsModalDemo;
